import React from "react"
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, Navigate } from "react-router-dom";
import Header from "../UserLayout/VersionHeader";
import CancelIcon from '@mui/icons-material/Cancel';


const NewVersion = () => {
    const { REACT_APP_TEKAVERSE } = process.env;

    const openTekaverse = () => {
        window.location.href = REACT_APP_TEKAVERSE;
    }
   
    return (
        <div>
            <Header></Header>
            <div className="invalid-QR">
                <div className="centered-wrapper">
                    <div className="icon-text-wrapper">
                        <CancelIcon onClick={() => openTekaverse()}
                           
                            style={{
                                color: "#b97a57", height: '50px',
                                width: '50px', cursor: "pointer" }}
                      
                        />        
                    </div>
                    <div className="invalid">
                        <h4> New Version available. Please use TEKaVerse to redirect TEKaHelp . Thanks </h4>
                    </div>
                </div>
            </div>


           {/* <Footer></Footer>*/}
        </div>
    )
}
export default connect()(NewVersion);
